<template>
  <div class="projectPortrait">
    <div class="cardList">
      <div v-for="(item,index) in cardList" :key="index" @click="goDetail(item.id)">
        <el-card class="box-card">
          <div class="cardCont">
            <img class="cardImg" :src="item.url" />
          </div>
          <p class="cardTitle">{{item.title}}</p>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
  /**
   *@ClassName:projectPortrait
   *@Description:项目画像
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2022-07-11
   */
  // import { mapGetters } from 'vuex'icon_project
  import icon1 from '../../../assets/imgs/car.png'
  // import icon4 from '../../assets/imgs/icon_project04.png'
  // import icon5 from '../../assets/imgs/icon_project05.png'
  // import icon6 from '../../assets/imgs/icon_project06.png'
  // import icon7 from '../../assets/imgs/icon_project07.png'
  // import icon8 from '../../assets/imgs/icon_project08.png'
  // import icon9 from '../../assets/imgs/icon_project09.png'
  // import icon10 from '../../assets/imgs/icon_project10.png'
  export default {
    name: '/manage/main.carDataAll',
    data() {
      return {
        cardList: [{
            id: 1,
            title: '月租车入场记录清理',
            url: icon1
          },
          {
            id: 2,
            title: '储值车入场记录清理',
            url: icon1
          },
          {
            id: 3,
            title: '临时车入场记录清理',
            url: icon1
          }
        ]
      }
    },
    created() {

    },
    methods: {
      goDetail(id) {
        if (id == 1) {
          this.$router.push({
            name: 'carInOutData'
          })
        } else if (id == 2) {
          this.$router.push({
            name: 'carInOutStoreData'
          })
        } else if (id == 3) {
          this.$router.push({
            name: 'carInOutTmpData'
          })
        } else if (id == 4) {
          this.$router.push({
            name: 'propertyContractList'
          })
        } else if (id == 6) {
          this.$router.push({
            name: 'gardenInfoAdministration'
          })
        } else if (id == 8) {
          this.$router.push({
            name: 'addLeaderInfo'
          })
        } else if (id == 10) {
          this.$router.push({
            name: 'addServiceInfo'
          })
        }
      }
    }
  }
</script>

<style lang="scss">
  .projectPortrait {
    .cardList {
      display: flex;
      flex-wrap: wrap;
    }

    .box-card {
      margin: 20px;
      padding: 20px;
    }

    .box-card .el-card__body {
      display: flex;
    }

    .cardCont {
      width: 65px;
      height: 65px;
    }

    .cardImg {
      width: 100%;
      height: 100%;
    }

    .cardTitle {
      line-height: 65px;
      font-size: 24px;
      margin: 0 10px;
      color: #999;
    }
  }
</style>